import React from 'react';
import { Link } from 'react-router-dom';
import '../index.css';

export const Footer = () => {
    return (
        <div>
            <footer className='bg-footer-brown bg-opacity-50 p-10 w-full h-full mt-auto bottom-0'>
                <div className='space-y-4'>
                    <ul className='flex'>
                        <Link to="/how-to-use" className='flex-1 text-center'>
                            <li className='text-black font-serif font-thin text-xs'>Chermoの使い方</li>
                        </Link>
                        <Link to="/inquiry" className='flex-1 text-center'>
                            <li className='text-black font-serif font-thin text-xs'>お問い合わせ</li>
                        </Link>
                        <Link to="/privacy-policy" className='flex-1 text-center'>
                            <li className='text-black font-serif font-thin text-xs'>プライバシーポリシー</li>
                        </Link>
                    </ul>
                    <div className='flex justify-center'>
                        <small className='text-black font-serif font-thin text-xs'>copy right. LocalHackers</small>
                    </div>
                </div>
            </footer>
        </div>
    );
}